export const CHANGE_WIDTH = 'UI/CHANGE_WIDTH';
export const FIRST_LOAD_COMPLETED = 'UI/FIRST_LOAD_COMPLETED';
export const TOGGLE_SIDE_MENU = 'UI/TOGGLE_SIDE_MENU';
